import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaYoutube } from 'react-icons/fa';

import CoE_Logo from '../../Assets/Images/Logo/CoElogo1_white.jpeg';

import './Footer.css';

const Footer = () => {

    const [visitorsCount, setVisitorsCount] = useState(null)

    return (
        <footer className="footer">
            <div className="container footer-container">

                <div className="footer-logo-section">
                    <img src={CoE_Logo} alt="SPA Logo" className="footer-logo" />
                    <h5>Centre of Excellence - Urban Planning and Design</h5>
                    <p>(Ministry of Housing and Affairs, Government of India)</p>
                    <h5>School of Planning and Architecture (SPA)</h5>
                    <p>4-Block-B, Indraprastha Estate, New Delhi 110002 India</p>
                </div>

                <div className="footer-links">
                    <div className="footer-links-column">
                        <h5>Quick Link</h5>
                        <Link to="/">Home</Link>
                        <Link to="/#">Downloads</Link>
                        <Link to="/#">Documents</Link>
                        <Link to="/#">Resources</Link>
                        <Link to="/vacancies">Vacancies</Link>
                        <Link to="/#">FAQs</Link>
                        <Link to="/contact">Contact Us</Link>
                    </div>

                    <div className="footer-links-column">
                        <h5>Important Links</h5>
                        <Link to="https://mohua.gov.in/" target="_blank">MoHUA</Link>
                        <Link to="https://spa.ac.in/" target='_blank'>SPA New Delhi</Link>
                        <Link to="/#">Privacy Policy</Link>
                        <Link to="/#">Terms and Conditions</Link>
                        <Link to="/#">Feedback</Link>
                        <Link to="/#">Disclaimer</Link>
                        <Link to="/#">Help</Link>
                    </div>

                    <div className="footer-links-column">
                        <h5>Follow Us</h5>
                        <div className="footer-social-icons d-flex">
                            <Link to="#" className=""><FaFacebookF /></Link>
                            <Link to="#" className="mx-2"><FaTwitter /></Link>
                            <Link to="#" className=""><FaYoutube /></Link>
                        </div>
                        <h5 className='mt-4'>Visitors: {visitorsCount}</h5>
                    </div>

                </div>
            </div>
        </footer>
    );
};

export default Footer;